import React, { useCallback, memo } from 'react';
import { Space } from 'antd';
import ImprovedConfigurationManager from './ImprovedConfigurationManager';
import ReportExportManager from './ReportExportManager';
import SimpleExportButton from "./SimpleExportButton";

// This component wraps the configuration manager and report export manager
// to prevent unnecessary re-renders in the main AnalyticsView component
const HeaderTools = ({
                         currentConfig,
                         dateRange,
                         onConfigChange,
                         onShowCallExport,
                         onShowScorecardExport,
                         onSyncConfig,
                         openExtendedExportModal
                     }) => {
    //console.log("Rendering HeaderTools");

    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <ImprovedConfigurationManager
                currentConfig={currentConfig}
                onConfigChange={onConfigChange}
            />
            {/*
            <SimpleExportButton/>

            }*/}
            <ReportExportManager
                currentConfig={currentConfig}
                dateRange={dateRange}
                onShowCallExport={onShowCallExport}
                onShowScorecardExport={onShowScorecardExport}
                onSyncConfig={onSyncConfig}
                openExtendedExportModal={openExtendedExportModal}
            />
        </div>
    );
};

// Export as memoized component to prevent unnecessary re-renders
export default  React.memo(HeaderTools, (prev, next) => {
    // Log what changed
    const changed = [];
    if (prev.currentConfig !== next.currentConfig) changed.push('currentConfig');
    if (prev.dateRange !== next.dateRange) changed.push('dateRange');
    if (prev.onConfigChange !== next.onConfigChange) changed.push('onConfigChange');
    if (prev.onShowCallExport !== next.onShowCallExport) changed.push('onShowCallExport');
    if (prev.onShowScorecardExport !== next.onShowScorecardExport) changed.push('onShowScorecardExport');
    if (prev.onSyncConfig !== next.onSyncConfig) changed.push('onSyncConfig');

    if (changed.length > 0) {
        //console.log('HeaderTools props changed:', changed.join(', '));
    }

    return changed.length === 0;
});

//export default HeaderTools;
